import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Banner from './Banner';
import ProfileManager from '../../services/api/ProfileManager';
import ReduxHooks from '../../store/ReduxHooks';
import { actionCreators } from '../../store/actions';
import { OrdersPauseReason } from '../../services/exports/Constants';
import { useHelpers } from '../../providers/HelpersProvider';
import { Button } from 'antd';
import { DateTime } from 'luxon';

export default function OrdersPausedManuallyBanner() {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Banners:OrdersPausedManuallyBanner' });

  const { formatTime } = useHelpers();

  const { company } = useSelector((state) => state.company);
  const [loading, setLoading] = useState(false);

  function ordersPausedManually() {
    const now = DateTime.local();

    return (
      company?.orders_pause_reason === OrdersPauseReason.Manual &&
      company?.orders_paused_from !== null &&
      DateTime.fromISO(company.orders_paused_from) < now &&
      company?.orders_paused_until !== null &&
      DateTime.fromISO(company.orders_paused_until) > now
    );
  }

  const unpauseOrders = async () => {
    setLoading(true);
    const { success, data } = await ProfileManager.unpauseOrders();
    setLoading(false);

    if (success) {
      ReduxHooks.dispatch(actionCreators.company.set(data.data));
    }
  };

  return (
    ordersPausedManually() && (
      <Banner
        type="warning"
        show
        className="w-full"
        title={
          <div className="flex">
            <span className="my-auto">
              {t('title', {
                time: DateTime.fromISO(company?.orders_paused_until).hasSame(DateTime.local().endOf('day'), 'second')
                  ? t('labels.rest_of_day')
                  : formatTime(company?.orders_paused_until),
              })}
            </span>
          </div>
        }
        rightAction={
          <Button danger variant="outlined" loading={loading} onClick={unpauseOrders} size="large">
            {t('button')}
          </Button>
        }
      />
    )
  );
}
